// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollbar-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.scrollbar-container .scroll-button {
  height: 26px;
  width: 26px;
  padding: 0px;
}
.scrollbar-container .scroll-slider {
  flex: 1;
}
.scrollbar-container .scroll-slider .ant-slider-track {
  background-color: #dee3ec;
}
.scrollbar-container .scroll-slider:hover .ant-slider-rail {
  background-color: #eceff4;
}
.scrollbar-container .scroll-slider:hover .ant-slider-track {
  background-color: #eceff4;
}
.vertical-scrollbar-container {
  flex-direction: column;
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./src/exports/NackleScroll/nackleScroll.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AADJ;AAHA;EAOQ,YAAA;EACA,WAAA;EACA,YAAA;AADR;AARA;EAaQ,OAAA;AAFR;AAXA;EAeY,yBAAA;AADZ;AAdA;EAqBY,yBAAA;AAJZ;AAjBA;EAwBY,yBAAA;AAJZ;AASA;EACI,sBAAA;EACA,WAAA;AAPJ","sourcesContent":["@import '../../less/color-vars.less';\n\n.scrollbar-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 10px;\n\n    .scroll-button {\n        height: 26px;\n        width: 26px;\n        padding:0px;\n    }\n\n    .scroll-slider {\n        flex: 1;\n        .ant-slider-track {\n            background-color: @gray-30;\n        }\n    }\n\n    .scroll-slider:hover {\n        .ant-slider-rail {\n            background-color: @gray-20;\n        }\n        .ant-slider-track {\n            background-color: @gray-20;\n        }\n    }\n}\n\n.vertical-scrollbar-container {\n    flex-direction: column;\n    width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
